/**
 * Idempotent Postgres DDL for Node self-host. Memory persistence implements
 * the same tables without executing SQL.
 *
 * Blobs are `bytea` on purpose: no MinIO/R2 until agents/sandboxes need a
 * filesystem. See internal/specs/self-host-node-postgres.md.
 */
export const POSTGRES_MIGRATE_STATEMENTS: readonly string[] = [
  `CREATE TABLE IF NOT EXISTS okra_documents (
  id TEXT PRIMARY KEY,
  owner_user_id TEXT NOT NULL,
  org_id TEXT,
  project_id TEXT,
  is_published BOOLEAN NOT NULL DEFAULT FALSE,
  spec JSONB NOT NULL DEFAULT '{}'::jsonb,
  meta JSONB NOT NULL DEFAULT '{}'::jsonb,
  graph JSONB NOT NULL DEFAULT '{}'::jsonb,
  phase TEXT NOT NULL DEFAULT 'idle',
  created_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
  updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
)`,
  `CREATE INDEX IF NOT EXISTS okra_documents_owner_idx ON okra_documents (owner_user_id)`,
  `CREATE TABLE IF NOT EXISTS okra_blobs (
  document_id TEXT NOT NULL REFERENCES okra_documents(id) ON DELETE CASCADE,
  kind TEXT NOT NULL CHECK (kind IN ('source', 'media')),
  name TEXT NOT NULL,
  content_type TEXT NOT NULL,
  bytes BYTEA NOT NULL,
  PRIMARY KEY (document_id, kind, name)
)`,
  `CREATE TABLE IF NOT EXISTS okra_leases (
  document_id TEXT PRIMARY KEY REFERENCES okra_documents(id) ON DELETE CASCADE,
  instance_id TEXT NOT NULL,
  expires_at TIMESTAMPTZ NOT NULL
)`,
];
